/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrmargin1Inputs */

const en_qrmargin1 = /** @type {(inputs: Qrmargin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margin`)
};

const de_qrmargin1 = /** @type {(inputs: Qrmargin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rand`)
};

/**
* | output |
* | --- |
* | "Margin" |
*
* @param {Qrmargin1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrmargin1 = /** @type {((inputs?: Qrmargin1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrmargin1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrmargin1(inputs)
	return de_qrmargin1(inputs)
});
export { qrmargin1 as "qrMargin" }